import type * as d3 from 'd3'

import type { ChartScales } from '@/features/bidding/types/bidLadder'

export function renderGridLines(g: d3.Selection<SVGGElement, unknown, null, undefined>, scales: ChartScales) {
  const { xScale, yScale, chartWidth, chartHeight } = scales
  const gridGroup = g.append('g').attr('class', 'grid')

  // Horizontal grid lines only, at major intervals (reduced from 12 to 6)
  const yTicks = yScale.ticks(6)
  const xTicks = xScale.ticks(6)
  gridGroup
    .selectAll('.grid-line-y')
    .data(yTicks)
    .enter()
    .append('line')
    .attr('class', 'grid-line-y')
    .attr('x1', 0)
    .attr('x2', chartWidth)
    .attr('y1', (d) => yScale(d))
    .attr('y2', (d) => yScale(d))
    .attr('stroke', '#e5e7eb')
    .attr('stroke-width', 1)
    .attr('opacity', 0.5)

  gridGroup
    .selectAll('.grid-line-x')
    .data(xTicks)
    .enter()
    .append('line')
    .attr('class', 'grid-line-x')
    .attr('x1', (d) => xScale(d))
    .attr('x2', (d) => xScale(d))
    .attr('y1', 0)
    .attr('y2', chartHeight)
    .attr('stroke', '#e5e7eb')
    .attr('stroke-width', 1)
    .attr('opacity', 0.5)
}
